import BaseUseCase from "../base_use_case.js";

class CreateUserWebIdUseCase extends BaseUseCase {

  execute() {
    return this.httpClient({
      ...this.requestConfig(),
      method: "post",
      url: `/api/v1/webid/user_actions`,
    });
  }
}

const instance = new CreateUserWebIdUseCase();
export default instance;